import {
  INDUSTRY_LIST,
  GEOLOCATION,
  COMPANY_TYPE,
  EMPLOYEE_COUNT,
  REVENUE_RANGE,
  COMPANYLIST,
  COMPANY_SEARCH_PAYLOAD,
  ADVANCED_SELECTED_FILTERS,
  PAGINATION_VALUE,
  SELECTED_RECORDS,
  SAVE_SEARCH,
  DOWNLOAD_COMPANYLIST_ERROR,
  SAVE_SEARCH_ERROR,
  INDUSTRY_LIST_ERROR,
  COMPANY_TYPE_ERROR,
  EMPLOYEE_COUNT_ERROR,
  REVENUE_RANGE_ERROR,
  COMPANYLIST_ERROR,
  EMPTY_ERROR_OBJ_LISTING,
  SAVE_SEARCH_LIST,
  SAVE_SEARCH_LIST_ERROR,
  COMPANY_TAG_LIST,
  COMPANY_TAG_LIST_ERROR,
  COMPANYQUICKSELECTIONLIST,
  COMPANYQUICKSELECTIONLIST_ERROR,
} from "../actionType/companyListingType";
import {
  getAuthMethod,
  getMethod,
  postAuthMethod,
} from "../services/HttpServices";
import { errEnum, ErrKey } from "../config";
import {
  industryApiUrl,
  employeeCountApiUrl,
  companyTypeApiUrl,
  revenueRangeApiUrl,
  companyListingApiUrl,
  saveSearch,
  saveSearchListApiUrl,
  getCompanyTagApiUrl,
  groupCompanyTagUrl,
  companySelectionApiUrl,
} from "../constant/Constant";
import { dispatchStatus } from "./commonActionCreator";
import { Geolocation } from "../constant/Geolocation";
import { getSubscriptionUserInfo } from "../utils/utils";
import moment from "moment";
import { formatCompanyPayload } from "../utils/formatCompanyPayload";

export const getIndustryList = (payload) => (dispatch) => {
  return getAuthMethod(industryApiUrl)
    .then((res) => {
      dispatch({
        type: INDUSTRY_LIST,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (!err?.response?.data) return;
      // console.log(err,'9798798')
      dispatch({
        type: INDUSTRY_LIST_ERROR,
        payload: { [errEnum.INDUSTRY_LIST_ERROR]: err || "Error Occured" },
      });
    });
};

export const getCompanyTypeList = (payload) => (dispatch) => {
  return getAuthMethod(companyTypeApiUrl)
    .then((res) => {
      dispatch({
        type: COMPANY_TYPE,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (!err?.response?.data) return;
      dispatch({
        type: COMPANY_TYPE_ERROR,
        payload:
          { [errEnum.COMPANY_TYPE_ERROR]: err.response.data[ErrKey] } ||
          "Error Occured",
      });
    });
};

export const getEmployeeCountList = (payload) => (dispatch) => {
  return getAuthMethod(employeeCountApiUrl)
    .then((res) => {
      dispatch({
        type: EMPLOYEE_COUNT,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (!err?.response?.data) return;
      dispatch({
        type: EMPLOYEE_COUNT_ERROR,
        payload:
          { [errEnum.EMPLOYEE_COUNT_ERROR]: err.response.data[ErrKey] } ||
          "Error Occured",
      });
    });
};

export const getRevenuerangeList = (payload) => (dispatch) => {
  return getAuthMethod(revenueRangeApiUrl)
    .then((res) => {
      dispatch({
        type: REVENUE_RANGE,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (!err?.response?.data) return;
      dispatch({
        type: REVENUE_RANGE_ERROR,
        payload:
          { [errEnum.REVENUE_RANGE_ERROR]: err.response.data[ErrKey] } ||
          "Error Occured",
      });
    });
};

export const getCompanyList = (payload) => (dispatch) => {
  dispatch(dispatchStatus(true));

  const url = formatCompanyPayload("/api/companies", payload);

  return getAuthMethod(url)
    .then((res) => {
      dispatch({
        type: COMPANYLIST,
        payload: res.data,
        count: res?.headers["x-total-count"],
      });
      dispatch(dispatchStatus(false));
    })
    .catch((err) => {
      if (!err?.response?.data) return;
      dispatch({
        type: COMPANYLIST_ERROR,
        payload:
          { [errEnum.COMPANYLIST_ERROR]: err.response.data[ErrKey] } ||
          "Error Occured",
      });
    });
};

export const getCompanyListWithStartAndEnd =
  (payload, paginationValues) => (dispatch) => {
    const url = formatCompanyPayload(
      `${companySelectionApiUrl}/${paginationValues?.start}/${paginationValues?.end}`,
      payload
    );
    return getMethod(url)
      .then((res) => {
        dispatch({
          type: COMPANYQUICKSELECTIONLIST,
          payload: res.data?.map((d) => d?.id),
          count: res?.headers["x-total-count"],
        });
      })
      .catch((err) => {
        if (!err?.response?.data) return;

        dispatch({
          type: COMPANYQUICKSELECTIONLIST_ERROR,
          payload:
            {
              [errEnum.COMPANYQUICKSELECTIONLIST_ERROR]:
                err.response.data[ErrKey],
            } || "Error Occured",
        });
      });
  };

export const downloadCompanyList = (payload, urlSubstring) => (dispatch) => {
  const url = `${companyListingApiUrl}/${urlSubstring}?id.in=${payload.join(",")}`;

  return getAuthMethod(url)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      if (err?.response?.status !== 403) {
        const isLimitExceed = err?.response?.data?.title
          ?.toLowerCase()
          ?.includes("subscriber ussage limit expired");

        const subscription = getSubscriptionUserInfo();
        const currentDate = moment();
        const validToDate = moment(subscription?.validTo);
        const isExpired = validToDate.isBefore(currentDate);
        dispatch({
          type: DOWNLOAD_COMPANYLIST_ERROR,
          payload: {
            [errEnum.DOWNLOAD_ERROR]: {
              message: subscription?.id
                ? isLimitExceed && !isExpired
                  ? "You have exceeded the download limit for your subscription plan."
                  : "Your subscription has expired. Please renew your subscription to continue using the service."
                : "You do not have an active subscription. Please subscribe to continue using the service.",
            },
          },
        });
      }
      return err;
    });
};

export const getLocation = (payload) => ({
  type: GEOLOCATION,
  payload: Geolocation,
});

export const createCompanySearchPayload = (payload) => {
  return {
    type: COMPANY_SEARCH_PAYLOAD,
    payload: payload,
  };
};

export const saveAdvancedSelectedFilters = (payload) => {
  window.scrollTo(0, 0);
  let customPayload = {};
  if (payload?.savedSearch) {
    // payload
    customPayload = {
      selectedCountry: [],
      selectedState: [],
      selectedCity: [],
      selectedIndustry: [],
      selectedCompanytype: [],
      selectedEmployeecount: [],
      selectedRevenuerange: [],
      searchKeyword: "",
      selectedSavedSearch: payload.selectedSavedSearch,
      selectedCompanyTag: [],
    };
  } else {
    customPayload = {
      ...payload,
      selectedSavedSearch: [],
    };
  }
  return {
    type: ADVANCED_SELECTED_FILTERS,
    payload: customPayload,
  };
};

export const savePaginationValues = (payload) => {
  return {
    type: PAGINATION_VALUE,
    payload: payload,
  };
};

export const selectedRow = (payload) => {
  return {
    type: SELECTED_RECORDS,
    payload: payload,
  };
};

export const resetQuickSelectedRow = (payload) => {
  return {
    type: COMPANYQUICKSELECTIONLIST,
    payload: payload,
  };
};

export const saveSearchAction = (payload) => (dispatch) => {
  return postAuthMethod(saveSearch, payload)
    .then((res) => {
      dispatch({
        type: SAVE_SEARCH,
        payload: res.data,
      });
      dispatch(saveSearchList(payload?.userId));
      return res;
    })
    .catch((err) => {
      dispatch({
        type: SAVE_SEARCH_ERROR,
        payload:
          { [errEnum.SAVE_SEARCH_ERROR]: err?.response?.data[ErrKey] } ||
          "Error Occured",
      });
      return err;
    });
};

export const emptyErrorObj = () => ({
  type: EMPTY_ERROR_OBJ_LISTING,
  payload: {},
});

export const saveSearchList = (userId) => (dispatch) => {
  const url = `${saveSearchListApiUrl}?source.equals=Company&userId.equals=${userId}`;
  return getAuthMethod(url)
    .then((res) => {
      dispatch({
        type: SAVE_SEARCH_LIST,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (!err?.response?.data) return;
      dispatch({
        type: SAVE_SEARCH_LIST_ERROR,
        payload:
          { [errEnum.SAVE_SEARCH_LIST_ERROR]: err.response.data[ErrKey] } ||
          "Error Occured",
      });
    });
};

export const createGroupCompanyTag = (payload) => (dispatch) => {
  return postAuthMethod(groupCompanyTagUrl, payload)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      return err;
    });
};

export const resetCompanySavedSearch = () => ({
  type: SAVE_SEARCH,
  payload: {},
});
